<h2 mat-dialog-title style="font-weight: normal; padding: 1.5rem 1.5rem 0px 1.5rem">
	<span *ngIf="!isCarrierFilterOpen" fxFlex>Enter Load Details</span>
	<span *ngIf="isCarrierFilterOpen" fxLayout="column">
		Filter Carriers
		<span *ngIf="isCarrierFilterOpen" class="font-size-14"
			>Select carriers to be excluded by the Booking Assistant. Then click Exclude.</span
		>
	</span>
	<span fxFlex fxLayoutAlign="end start">
		<mat-icon (click)="closeDialog()" class="primary-light-color cursor-pointer">close</mat-icon>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content style="padding: 1.5rem 1.5rem 0rem 1.5rem; margin: 1px">
	<app-load-details-template
		*ngIf="!isCarrierFilterOpen"
		(loadCreated)="closeDialog()"
		(switchToCarrierFilter)="switchToCarrierFilter($event)"
		[data]="data"
		[postLoad]="false"
		[oldLoadDetails]="loadDetails"
		[excludedCarrierIds]="excludedCarrierIds"
	>
	</app-load-details-template>
	<app-carrier-filter
		#carrierFilter
		*ngIf="isCarrierFilterOpen"
		(switchToLoadDetails)="switchToLoadDetails($event)"
		[matchedCarriers]="data.matchedCarriers"
		[oldSelection]="selection"
	>
	</app-carrier-filter>
</mat-dialog-content>
